import { toast } from 'material-react-toastify';

import { hubApi, withAuthHeader } from '@/lib/backend/api';
import { getAuthToken } from '@/lib/firebase/token';
import { sessionKeys } from '@/lib/query/keys/sessions';
import { isSuccess } from '@/lib/utils/response';
import { SessionHub } from '@addmile/backend-client';
import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';

export const useSessionDetail = (sessionId: string | undefined) => {
  return useQuery<SessionHub | undefined, Error>({
    queryKey: sessionId ? sessionKeys.detail(sessionId) : ['sessions', 'detail'],
    queryFn: async () => {
      if (!sessionId) throw new Error('Session ID is required');
      try {
        const token = await getAuthToken();
        const { data: session, status } = await hubApi.getSessionByUserIDHub(
          sessionId,
          withAuthHeader(token),
        );
        if (isSuccess(status)) {
          return session;
        }
      } catch (error) {
        Sentry.captureException(`Failed to fetch session: ${error.message}`);
        toast.error(`Failed to fetch session: ${error.message}`);
        return undefined;
      }
    },
    enabled: !!sessionId,
    staleTime: 30 * 1000, // 30 seconds
  });
};
